<button type="button" class="btn btn-outline-dark" [disabled]="isLoading">
  <ng-container *ngIf="!isLoading">
    {{ loadMoreMsg }}
  </ng-container>
  <span class="loading-btn" *ngIf="isLoading">
    <app-loader></app-loader>
    <span>{{ loadingMsg }}</span>
  </span>
</button>
